import Box from '@mui/material/Box';
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Link, useMatch, useResolvedPath } from "react-router-dom"

export default function PDBlurb() {
    return (
        <>
            <Box>
                <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                    <b><Link to="/about" style={{ textDecoration: 'none', color: '#a60202' }}>Profession</Link></b>
                </Typography>
                <Typography variant='body2' fontFamily='Proxima Nova' gutterBottom>
                Profession is one of the three main tenets of Theta Tau. We strive to provide resources and educational opportunities for both new members and brothers, with the hope that all brothers will develop the confidence, awareness, and lifelong skills applicable to whatever profession they choose. Throughout the year, we host professional workshops, resume critiques, and Alumni Panel Talks. 
                ​</Typography>
            </Box>
        </>
    );
  }